import { Component } from '@angular/core';
import { AgefiphService } from 'src/app/services/agefiph.service';

@Component({
    selector: 'app-reponse-number',
    templateUrl: './reponse-number.component.html',
    styleUrls: ['./reponse.component.scss']
})
export class ReponseNumberComponent {

    constructor(public agefiphService: AgefiphService) {

    }

}
